import React from 'react';
import {
  Typography,
  Box,
  Divider,
  Chip,
  Button,
} from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import { WidgetContainer } from '../../widgets.styles';
import { useNavigate } from 'react-router-dom';

// Mock data - will be replaced with real data from Firestore
const trendingWorkouts = [
  {
    id: '1',
    name: '5x5 Stronglifts',
    category: 'Strength',
    usersCount: 1240,
  },
  {
    id: '2',
    name: 'Couch to 5K',
    category: 'Cardio',
    usersCount: 892,
  },
  {
    id: '3',
    name: 'Morning Yoga Flow',
    category: 'Flexibility',
    usersCount: 634,
  },
];

const categoryColors = {
  Strength: 'error',
  Cardio: 'warning',
  Flexibility: 'secondary',
};

/**
 * Trending Workouts widget - popular workout templates from the community.
 * Uses mock data for now.
 */
const TrendingWorkouts = () => {
  const navigate = useNavigate();

  return (
    <WidgetContainer>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 2.5, pb: 1 }}>
        <TrendingUpIcon sx={{ fontSize: 20, color: 'primary.main' }} />
        <Typography variant="h6" color="text.primary">
          Trending Workouts
        </Typography>
      </Box>
      <Typography sx={{ px: 2.5, pb: 2 }} variant="caption" color="text.secondary">
        Popular with the community
      </Typography>
      <Divider />
      <Box sx={{ py: 1 }}>
        {trendingWorkouts.map((workout, index) => (
          <React.Fragment key={workout.id}>
            {index > 0 && <Divider />}
            <Box
              sx={{
                px: 2.5,
                py: 1.5,
                cursor: 'pointer',
                '&:hover': { backgroundColor: 'action.hover' },
                transition: 'background-color 0.15s',
              }}
              onClick={() => navigate('/workouts')}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                  {workout.name}
                </Typography>
                <Chip
                  label={workout.category}
                  size="small"
                  color={categoryColors[workout.category] || 'default'}
                  variant="outlined"
                  sx={{ fontSize: '0.65rem', height: 22 }}
                />
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <PeopleIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                <Typography variant="caption" color="text.secondary">
                  {workout.usersCount.toLocaleString()} people training
                </Typography>
              </Box>
            </Box>
          </React.Fragment>
        ))}
      </Box>
      <Divider />
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 1.5 }}>
        <Button size="small" onClick={() => navigate('/explore')}>
          Explore more
        </Button>
      </Box>
    </WidgetContainer>
  );
};

export default TrendingWorkouts;
